import { Facebook, Instagram } from 'lucide-react'

import logoUrl from '@/assets/images/logo.png'

type SocialLinkProps = React.PropsWithChildren &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

const SocialLink = ({ children, ...props }: SocialLinkProps) => (
  <a
    className="grid size-10 place-items-center rounded-md border border-gray-700 bg-white text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-300"
    target="_blank"
    {...props}
  >
    {children}
  </a>
)

export const Footer = () => (
  <footer className="container flex flex-col items-center gap-4 p-4">
    <img className="w-40" src={logoUrl} alt="Logomarca Bar Fácil" />

    <a
      className="rounded p-1 text-sm hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-300"
      href="mailto:contato@agapesolucoes.com.br"
      target="_blank"
      rel="noreferrer"
    >
      contato@agapesolucoes.com.br
    </a>

    <div className="flex gap-2">
      <SocialLink href="https://www.instagram.com/barfaciloficial">
        <Instagram size={24} />
      </SocialLink>

      <SocialLink href="https://www.facebook.com/Barfacil">
        <Facebook size={24} />
      </SocialLink>
    </div>

    <span className="text-xs font-medium">2024 ©AGP</span>
  </footer>
)
